import {
  GET_TAGS,
  ADD_TAG,
  UPDATE_TAG,
  DELETE_TAG,
} from "./types";

const initialState = {
  tags: [],
  totalTags: 0,
};

const tagReducer = (state = initialState, action) => {
  switch (action.type) {
    /* ─────────── list ─────────── */
    case GET_TAGS:
      return {
        ...state,
        tags: action.payload.tags,
        totalTags: action.payload.total,
      };

    /* ─────────── create ─────────── */
    case ADD_TAG:
      return {
        ...state,
        tags: [action.payload, ...state.tags],
        totalTags: state.totalTags + 1,
      };

    /* ─────────── update ─────────── */
    case UPDATE_TAG:
      return {
        ...state,
        tags: state.tags.map((t) =>
          t._id === action.payload._id ? action.payload : t
        ),
      };

    /* ─────────── delete ─────────── */
    case DELETE_TAG:
      return {
        ...state,
        tags: state.tags.filter((t) => t._id !== action.payload),
        totalTags: state.totalTags - 1,
      };

    default:
      return state;
  }
};

export default tagReducer;
